import React, { ReactNode } from 'react';
import { Tooltip, TooltipTrigger } from '../../ui/tooltip';
import { SidebarTooltipContent } from './sidebar-tooltip-content';
import { cn } from '../../../utils';

interface SidebarLinkWithTooltipProps {
  href: string;
  tooltipContent: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  id?: string;
}

/**
 * Wrapper component that combines a Link with a Tooltip.
 * Handles the pattern where Radix UI Tooltip's asChild requires proper ref forwarding,
 * which regular anchor tags don't support directly.
 */
export function SidebarLinkWithTooltip({
  href,
  tooltipContent,
  className,
  style,
  children,
  onClick,
  id,
}: SidebarLinkWithTooltipProps) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <div className={cn('tw-relative', className)} style={style}>
          <a
            id={id}
            href={href}
            onClick={onClick}
            className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-px-3 tw-no-underline"
          >
            {children}
          </a>
        </div>
      </TooltipTrigger>
      <SidebarTooltipContent
        side="right"
        sideOffset={15}
        className="tw-bg-gray-900/95 tw-text-white tw-border tw-border-gray-700/50 tw-shadow-lg tw-backdrop-blur-sm tw-px-3 tw-py-2.5 tw-rounded-md"
      >
        {tooltipContent}
      </SidebarTooltipContent>
    </Tooltip>
  );
}
